<template>
  <div class="later-available-reminder">
    <span
      class="later-available-reminder__message later-available-reminder__message--type_success"
      v-if="message"
    >
      {{ message }}
    </span>
    <Form
      v-else
      :action="productReminderUrl"
      ref="laterAvailableReminderForm"
      @submit="onSubmit"
    >
      <csrf-input
        ref="csrf"
      />
      <div class="form__group">
        <input-vee4
          name="email"
          type="email"
          :placeholder="$t('global.email.label')"
          rules="required|email|min:5|max:100"
          :button="{type: 'submit'}"
        />
      </div>
    </Form>
  </div>
</template>

<script>
  import productPageStateComputedMixin
    from '../../utilities/vueMixins/productPageStateComputedMixin/productPageStateComputedMixin.js';
  import InputVue from '../inputVue/inputVue.vue';
  import CsrfInput from '../csrfInput/csrfInput.vue';
  import FormMixin from '../../utilities/vueMixins/formMixin/formMixin';
  import pigeon from '../../utilities/js/pigeon/pigeon.js';
  import { Form } from "vee-validate";
  import InputVee4 from "../inputVue/inputVee4.vue";

  export default {
    components: {
      InputVee4,
      Form,
      CsrfInput,
      InputVue
    },
    mixins: [
      FormMixin,
      productPageStateComputedMixin
    ],
    data() {
      return {
        message: '',
      };
    },
    mounted() {
      pigeon.subscribe('formsubmit:success', this.handleFormSubmit.bind(this));
      pigeon.subscribe('formsubmit:error', () => this.message = null);
    },
    methods: {
      onSubmit(values, actions) {
        this.submitAjaxFormVee4(values, (errors) => {
          errors.forEach(fieldError => {
            actions.setFieldError(fieldError.field, fieldError.msg)
          })
        });
      },
      handleFormSubmit(id) {
        if (id === this.id) {
          this.message = this.$t('product.reminder.success.message');
          this.$refs.laterAvailableReminderForm.reset()
        }
      }
    }
  };

</script>
